export const LaCon = 'http://api.doevidas.com.br/';//'http://192.168.0.5:8000/';//
export const SelfLink = 'http://www.cidadeinteligente.com.br/';
export const Passport = '4nADT6SHdCZ3VsmOFakUrzBkdFZSqGZ0OVbSEE27';